module.exports = __webpack_public_path__ + "img/seating-classroom.687d9c00.svg";